export default __webpack_public_path__ + "static/media/app-bar-logo.342d0db3.svg";